import {
    EDIT_SWAP_SIM_CARD_OPEN_MODAL,
    EDIT_SWAP_SIM_CARD_CLOSE_MODAL,
    EDIT_SWAP_SIM_CARD_GET_DEVICE_REQUEST,
    EDIT_SWAP_SIM_CARD_GET_DEVICE_RESULT,
    EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_REQUEST,
    EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_RESULT,
    EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_REQUEST,
    EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    devices: [],
    device: null,
    simDetails: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case EDIT_SWAP_SIM_CARD_OPEN_MODAL:
            return { ...state, openModal: true, devices: action.payload }

        case EDIT_SWAP_SIM_CARD_CLOSE_MODAL:
            return { ...state, openModal: false, devices: null }

        case EDIT_SWAP_SIM_CARD_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case EDIT_SWAP_SIM_CARD_GET_DEVICE_RESULT:
            return { ...state, loading: false, device: action.payload }

        case EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_REQUEST:
            return { ...state, loading: true }

        case EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_RESULT:
            return { ...state, loading: false, simDetails: action.payload }

        case EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_REQUEST:
            return { ...state, loading: true }

        case EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "EDIT_SWAP_SIM_CARD"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};